import { useEffect } from "react";
import { useRootSelector } from "../hooks/useAppSelector";
import { messages } from "../utils/constants";
import { getRootAppWindow } from "meta/utils/getRootAppWindow";
export const useDashboardInteraction = () => {
    const { activeTabKey } = useRootSelector();
    const topFrame = getRootAppWindow(window);
    const dashboardInteractions = {
        openVerticalTab: (menuId) => topFrame?.frames[activeTabKey]?.RootCommunicator.openChartTab(menuId),
        modifiedUpdate: (modified) => topFrame?.frames[activeTabKey]?.RootCommunicator.modifiedUpdate(modified)
    };
    const handleDashboardInteraction = (message) => {
        if (message.data.type === "DASHBOARD_INTERACTION" && message.data.name !== undefined) {
            const dashboardInteraction = message.data;
            const interactionName = message.data.name;
            const onInteractionInvalid = (text) => {
                console.error(messages.dashboardInteractionFailedConsole(text, interactionName, dashboardInteraction.payload));
                window.DialogManager.LocalDialog.alert("Operation not supported", messages.dashboardInteractionInvalidOperation(text));
            };
            const onDataError = (text) => {
                console.error("Operation failed.", messages.dashboardInteractionFailedConsole(text, interactionName, dashboardInteraction.payload));
                window.DialogManager.LocalDialog.alert("Operation failed", messages.dashboardInteractionDataError(text, interactionName, dashboardInteraction.payload));
            };
            const interaction = dashboardInteractions[interactionName];
            if (interaction) {
                try {
                    interaction(dashboardInteraction.payload);
                }
                catch (error) {
                    if (error.name === "UnsupportedError") {
                        onInteractionInvalid(error.message);
                    }
                    else if (error.name === "DataError") {
                        onDataError(error.message);
                    }
                    else {
                        console.error(error);
                        onInteractionInvalid("Action code failed with an error. See previous log message for the error.");
                    }
                }
            }
            else {
                onInteractionInvalid("Interaction not found.");
            }
        }
    };
    useEffect(() => {
        window.addEventListener("message", handleDashboardInteraction);
        return () => window.removeEventListener("message", handleDashboardInteraction);
    }, [, activeTabKey]);
};
